import {
  List,
  Datagrid,
  NumberField,
  DateField,
  TopToolbar,
  ExportButton,
  FunctionField,
  ReferenceField,
  TextField,
  useDataProvider,
  useNotify,
} from "react-admin";
import { Link, useParams } from "react-router-dom";
import InventoryGraph from "./ClientIventoryGraph";
import {
  Chip,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Divider,
} from "@mui/material";
import React from "react";
import {
  createdFromCILabels,
  createdFromCIMap,
} from "../interfaces/ClientInventory.interface";

const nbrChoices = [
  { id: "fullBinsCount", name: "Caisses pleines" },
  { id: "emptyBinsCount", name: "Caisses vides" },
  { id: "airbagsCount", name: "Nb airbag en vrac" },
];

const DetailsStats: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let preFilterValue: any = [];
  if (id) {
    preFilterValue = JSON.stringify([{ name: "client", value: id }]);
  }

  const dataProvider = useDataProvider();
  const [counts, setCounts] = React.useState<Record<string, number>>({
    airbagsCount: 0,
    fullBinsCount: 0,
    emptyBinsCount: 0,
  });

  React.useEffect(() => {
    dataProvider
      .getList("client-inventory", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "createdAt", order: "DESC" },
        meta: { preFilter: preFilterValue },
      })
      .then(({ data }) => {
        data.forEach((element) => {
          setCounts((prev) => ({
            ...prev,
            airbagsCount: element.airbagsCount,
          }));
          setCounts((prev) => ({
            ...prev,
            emptyBinsCount: element.emptyBinsCount,
          }));
          setCounts((prev) => ({
            ...prev,
            fullBinsCount: element.fullBinsCount,
          }));
        });
      });
  }, [dataProvider, preFilterValue]);

  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2, mt: 2 }}>
      {nbrChoices.map(({ id, name }) => (
        <>
          <Card
            sx={{
              width: "100%",
              textAlign: "center",
              bgcolor: (theme) => theme.palette.background.paper,
            }}
          >
            <CardContent>
              <Typography variant="subtitle2">{name} sur site</Typography>
              <Typography variant="h6">{counts[id]}</Typography>
            </CardContent>
          </Card>
        </>
      ))}
    </Stack>
  );
};

const InventoryListActions = () => {
  const { id } = useParams<{ id: string }>();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const handleGetInviteUrl = React.useCallback(async () => {
    try {
      const response = await dataProvider.getInviteUrl("clients", {
        id,
      });
      window.open(response, "_blank");
    } catch (error) {
      console.error(error);
      notify("Error fetching invite URL", { type: "error" });
    }
  }, [dataProvider, id, notify]);

  return (
    <TopToolbar>
      {id && (
        <>
          <Button
            component={Link}
            to={`/clientInventory/create?clientId=${id}`}
            variant="outlined"
            color="success"
            size="small"
          >
            Ajouter inventaire
          </Button>
          <Button
            onClick={handleGetInviteUrl}
            color="warning"
            variant="outlined"
            size="small"
          >
            Lien d'inventaire client
          </Button>
        </>
      )}
      <ExportButton />
    </TopToolbar>
  );
};

export const ClientInventoryDetails: React.FC = (props) => {
  const { id } = useParams<{ id: string }>();
  let preFilterValue: any = [];
  if (id) {
    preFilterValue = JSON.stringify([{ name: "client", value: id }]);
  }

  return (
    <>
      <DetailsStats />
      <List
        {...props}
        resource="client-inventory"
        actions={<InventoryListActions />}
        sort={{ field: "createdAt", order: "DESC" }}
        queryOptions={{
          meta: { preFilter: preFilterValue },
        }}
        title="Inventaire du client"
      >
        <Datagrid>
          <ReferenceField
            label="Client"
            source="client"
            reference="clients"
            link={false}
          >
            <TextField source="internalCode" /> - <TextField source="name" />
          </ReferenceField>
          <NumberField source="fullBinsCount" label="Caisses pleines" />
          <NumberField source="emptyBinsCount" label="Caisses vides" />
          <NumberField source="airbagsCount" label="Nb airbag en vrac" />
          <DateField
            source="createdAt"
            label="Date création"
            locales="fr-FR"
            options={{
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            }}
          />
          <FunctionField
            source="createdFrom"
            label="Ajouté par"
            render={(record) => {
              const label =
                createdFromCILabels[record.createdFrom] || record.createdFrom;
              const color = createdFromCIMap[record.createdFrom] || "default";
              return <Chip label={label} color={color} size="small" />;
            }}
          />
          <TextField source="comment" label="Commentaire" />
        </Datagrid>
      </List>
      <Divider sx={{ mb: 2 }} />
      {id && <InventoryGraph clientId={id} />}
    </>
  );
};
